function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { CheckBoxField, Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from '@unite-us/ui';
function ContactDocumentsSelector(_ref) {
  var _ref$documentFields = _ref.documentFields,
    initialDocumentFields = _ref$documentFields === void 0 ? [] : _ref$documentFields;
  var _useState = useState(initialDocumentFields),
    _useState2 = _slicedToArray(_useState, 2),
    documentFields = _useState2[0],
    setDocumentFields = _useState2[1];
  useEffect(function () {
    setDocumentFields(initialDocumentFields);
  }, [initialDocumentFields]);
  var openInNewWindow = function openInNewWindow(url) {
    window.open(url);
  };
  var handleOnCheck = function handleOnCheck(index) {
    var updatedDocumentFields = _toConsumableArray(documentFields);
    updatedDocumentFields[index].attached = !updatedDocumentFields[index].attached;
    setDocumentFields(updatedDocumentFields);
  };
  if (isEmpty(documentFields)) {
    return null;
  }
  var rows = documentFields.map(function (field, i) {
    var documentTitle = field.document.title;
    var documentUrl = field.document.url;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: i,
      clickable: false
    }, /*#__PURE__*/React.createElement(TableRowColumn, {
      className: "contact-documents-selector__checkboxes"
    }, /*#__PURE__*/React.createElement("div", {
      "data-test-element": "document-".concat(i, "-checkbox")
    }, /*#__PURE__*/React.createElement(CheckBoxField, {
      id: "document-".concat(i, "-checkbox"),
      checked: field.attached,
      label: "",
      hideLabel: true,
      showError: false,
      showHint: false,
      onChange: function onChange() {
        return handleOnCheck(i);
      }
    }))), /*#__PURE__*/React.createElement(TableRowColumn, null, documentUrl ? /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        return openInNewWindow(documentUrl);
      }
    }, documentTitle) : documentTitle), /*#__PURE__*/React.createElement(TableRowColumn, null), /*#__PURE__*/React.createElement(TableRowColumn, null));
  });
  return /*#__PURE__*/React.createElement(Table, {
    id: "contact-documents-selector-table",
    className: "contact-documents-selector"
  }, /*#__PURE__*/React.createElement(TableHeader, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableHeaderColumn, null), /*#__PURE__*/React.createElement(TableHeaderColumn, null, "File Name"), /*#__PURE__*/React.createElement(TableHeaderColumn, null, "Uploaded By"), /*#__PURE__*/React.createElement(TableHeaderColumn, null, "Date Modified"))), /*#__PURE__*/React.createElement(TableBody, null, rows));
}
ContactDocumentsSelector.propTypes = {
  documentFields: PropTypes.array
};
ContactDocumentsSelector.defaultProps = {
  documentFields: []
};
export default ContactDocumentsSelector;
//# sourceMappingURL=ContactDocumentsSelector.js.map